import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Must match the DayColumn header height so labels align with the events area
export const DAY_HEADER_HEIGHT = 42

export default function TimeColumn({ hourStart, hourEnd }) {
  const hours = []
  for (let h = hourStart; h <= hourEnd; h++) {
    hours.push(h)
  }

  return (
    <Box sx={{ position: 'relative', width: 50, flexShrink: 0 }}>
      {hours.map(h => (
        <Typography
          key={h}
          variant="caption"
          sx={{
            position: 'absolute',
            top: `${DAY_HEADER_HEIGHT + (h - hourStart) * 60 - 8}px`,
            right: 4,
            color: 'text.secondary',
            fontSize: '0.7rem',
            userSelect: 'none',
          }}
        >
          {h.toString().padStart(2, '0')}:00
        </Typography>
      ))}
    </Box>
  )
}
